<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>财务系统</el-breadcrumb-item>
            <el-breadcrumb-item>加款记录</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-input
                size="small"
                clearable
                v-model="searchForm.searchName"
                placeholder="请输入账户名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input size="small" clearable v-model="searchForm.searchID" placeholder="请输入账户ID"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select
                clearable
                size="small"
                v-model="searchForm.searchType"
                placeholder="请选择是否还款"
              >
                <el-option label="是" value="是"></el-option>
                <el-option label="否" value="null"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search"  @click="Search">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="transferAmounts" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="SubmissionTime" label="提交时间"></el-table-column>
            <el-table-column prop="SubmitDepartmentName" label="提交部门"></el-table-column>
            <el-table-column prop="Initiator" label="客服"></el-table-column>
            <el-table-column prop="AddAmountDate" label="加款时间"></el-table-column>
            <el-table-column prop="AcountName" label="账户名称"></el-table-column>
            <el-table-column prop="AcountID" label="账户ID"></el-table-column>
            <el-table-column prop="Amount" label="加款金额"></el-table-column>
            <el-table-column prop="PreReturnDate" label="预计还款时间"></el-table-column>
            <el-table-column prop="ReturnType" label="还款方式"></el-table-column>
            <el-table-column prop="IsReturn" :formatter="isReturn" label="是否还款"></el-table-column>
            <el-table-column prop="RealReturnDate" label="实际还款日期"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.Reason" placement="left" effect="light">
                  <el-button type="text">加款原因</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.Note" placement="left" effect="light">
                  <el-button type="text">备注</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { GetTransferAmountList } from "../../until/ZeusApiSDK/Logic/FinancialLogic";
import { GetCurrentUserInfo,GetCurrentUserRole } from "../../until/ZeusApiSDK/Logic/HomeLogic";
export default {
  data() {
    return {
      searchForm: {
        searchName: "",
        searchID: "",
        searchType: ""
      },

      transferAmounts: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true
    };
  },
  created() {
    this.GetTransferAmount();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetTransferAmount();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetTransferAmount();
    },
    Search: function() {
      this.pageIndex = 1;
      this.GetTransferAmount();
    },
    //刷新
    Refresh:function(){
      this.GetTransferAmount();
    },
    GetTransferAmount:async function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      var currentUserRole = await GetCurrentUserRole();
      var userid = "";
      if (currentUserRole.Key != "admin") {
        userid=userinfo.UserId
      }
      GetTransferAmountList(
        userid,
        this.searchForm.searchName,
        this.searchForm.searchID,
        this.searchForm.searchType,
        this.pageIndex,
        this.pageSize,
        this.searchName
      ).then(pageRes => {
        this.transferAmounts = pageRes.DataList;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    isReturn(row, column, cellValue, index) {
      if (cellValue == "是") {
        return "已还款";
      } else {
        return "未还款";
      }
    }
  }
};
</script>
